module.exports = __webpack_public_path__ + "img/mp-img-3.67f27931.jpg";